import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginLogo } from '../components/LoginLogo';
import { LoginAlert } from '../features/Login/components';
import { MfaVerifyForm } from '../features/Login/components/MfaVerifyForm';
import { FullScreenBackground, RightSpacer } from '../styles/LoginContainerStyle';

interface MfaState {
  email: string;
  session: string;
}

export function MfaVerify() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as MfaState | null;

  useEffect(() => {
    if (!state?.email || !state.session) {
      navigate('/', { replace: true });
    }
  }, [state, navigate]);

  if (!state?.email || !state.session) {
    return null;
  }

  return (
    <>
      <LoginAlert />
      <FullScreenBackground>
        {/* left space */}
        <LoginLogo />

        {/* right space */}
        <RightSpacer>
          <img src="/images/icon_basic.png" alt="ProPlus" style={{ height: 40 }} />
          <MfaVerifyForm email={state.email} session={state.session} />
        </RightSpacer>
      </FullScreenBackground>
    </>
  );
}
